import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface ServicesProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Services
  location: PageProps['location']
}

interface PostProps {
  [key: string]: any
}

const ServicesShell: React.FC<ServicesProps> = ({ fields, location }) => {
  const types: PostProps = {
    grid: loadable(() => import('components/flex/Services/Services')),
    horizontal: loadable(
      () => import('components/flex/Services/ServicesHorizontal')
    ),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default ServicesShell
